import { useEffect, useRef } from "react";
import posthog from "posthog-js";
import { isAnalyticsHost } from "../lib/analytics-host";

const POSTHOG_KEY = "phc_tGvbpFMfPfhtfWDFhTRZ7ARVRhRgui3dviWW8q6SUrtM";
const POSTHOG_HOST = "https://eu.i.posthog.com";

function isAnalyticsAllowed(): boolean {
  try {
    const prefs = localStorage.getItem("cookie-preferences");
    if (!prefs) return false;
    return JSON.parse(prefs).analytics === true;
  } catch {
    return false;
  }
}

export function PostHog() {
  const initializedRef = useRef(false);

  const init = () => {
    if (initializedRef.current || posthog.__loaded) return;
    if (!isAnalyticsHost()) return;
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      defaults: "2026-01-30",
      person_profiles: "identified_only",
      // Must be "history_change", not `true`. The landing is a pushState SPA
      // (see navigate() in App.tsx), and posthog-js only patches the History
      // API when this is exactly "history_change" — with `true` it captures a
      // pageview on init and never again, so every internal navigation
      // (/vorsprung-demo → /demo, → /faq …) went uncounted. `defaults` already
      // implies this value; passing `true` was silently overriding it.
      capture_pageview: "history_change",
      capture_pageleave: true,
    });
    initializedRef.current = true;
  };

  // Init on mount if consent already given
  useEffect(() => {
    if (isAnalyticsAllowed()) init();
  }, []);

  // Init when consent is granted via the consent banner
  useEffect(() => {
    const handler = (e: Event) => {
      const prefs = (e as CustomEvent).detail;
      if (prefs?.analytics) init();
    };
    window.addEventListener("cookie-consent-changed", handler);
    return () => window.removeEventListener("cookie-consent-changed", handler);
  }, []);

  return null;
}
